import constants from '../../config'

const state = {

}

// getters
const getters = {

}

// actions
const actions = {

  async register({dispatch, commit}, form) {
    let endpoint = `register/step-${form.step}`

    if (form.opType === 'update') {
      form['_method'] = 'put'
    }

    return form.submit('post', endpoint)
  },
}


// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}